import styled, { css } from 'styled-components'

import { basketWidth } from '@src/constants/basketWidth'
import { breakpoints } from '@src/constants/breakpoints'
import { removeScrollbar } from '@src/pages/global.styles'

export const Container = styled.div<{ $isStackedMenuView: boolean }>`
  background-color: white;
  width: 100vw;
  overflow: hidden;
  display: flex;
  flex-direction: ${({ $isStackedMenuView }) =>
    $isStackedMenuView ? 'column' : 'row'};
  ${({ $isStackedMenuView }) =>
    $isStackedMenuView
      ? 'justify-content: space-between;'
      : 'height: 56px; align-items: top'}

  border-bottom: 1px solid rgba(149, 157, 165, 0.2);
  box-shadow: rgba(149, 157, 165, 0.4) 0px -8px 24px;
`

export const CapsuleContainer = styled.div<{ $forOutletList?: boolean }>`
  display: flex;
  padding: 8px 18px;
  overflow-y: hidden;
  overflow-x: auto;
  align-items: center;
  ${({ $forOutletList = false }) =>
    $forOutletList ? 'width: auto;' : 'width: 100%;'}
  ${removeScrollbar};

  @media (min-width: ${breakpoints.tablet}px) {
    padding: 0px 24px;
    ${({ $forOutletList = false }) =>
      $forOutletList ? 'margin-left: 10px; margin-top: 15px' : ''}
  }
`

export const FilterOverlay = styled.div`
  position: absolute;
  height: 52px;
  top: 11px;
  width: 52px;
  background-color: white;
  z-index: 1;
  right: 0px;
  background: linear-gradient(
    to left,
    rgba(255, 255, 255, 1) 25%,
    rgba(255, 255, 255, 0)
  );
`

const baseCapsuleStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  user-select: none;
`

export const Capsule = styled.button<{
  active: boolean
  $forOutletList?: boolean
}>`
  ${baseCapsuleStyles}
  height: 32px;
  font-weight: 700;
  padding: ${({ active }) => (active ? `6px 12px` : `6px 2px`)};
  margin: 8px 16px 8px 0px;
  color: ${({ active, theme }) =>
    active ? theme.colors.brandDark : theme.colors.brand};
  background: ${({ active, theme }) =>
    active ? theme.colors.brandLight : 'transparent'};
  font-size: ${({ $forOutletList = false }) =>
    $forOutletList ? '17px' : '14px'};

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 16px;
    height: 36px;
  }

  ${({ active, theme }) =>
    !active &&
    css`
      &:hover {
        color: ${theme.colors.brandLight};
      }
    `}
`

export const OutletMenuSearchContainer = styled.div<{
  $isStackedMenuView: boolean
  displayPermanentCheckout: boolean
}>`
  display: flex;
  align-items: center;
  ${({ $isStackedMenuView }) => ($isStackedMenuView ? 'margin-top: 10px;' : '')}

  @media (min-width: ${breakpoints.largeTablet}px) {
    margin-right: 16px;
  }

  ${({ displayPermanentCheckout }) =>
    displayPermanentCheckout &&
    css`
      @media (min-width: ${breakpoints.wideDesktop}px) {
        margin-right: ${basketWidth.superWideDesktop}px;
      }

      @media (min-width: ${breakpoints.superWideDesktop}px) {
        margin-right: calc(${basketWidth.superWideDesktop}px + 10px);
      }
    `}
`
